import { ContractorAssociations } from "@/api/williams/contractors";
import { ExpandableCard } from "../../components";
import { useContractorAssociations } from "../hooks";

export function Associations({ contractorId }: { contractorId: string }) {
  const associations = useContractorAssociations(contractorId);

  return (
    <ExpandableCard caption="Associations">
      {associations.isLoading ? (
        <p>Loading...</p>
      ) : associations.isError ? (
        <p>An unknown error occurred.</p>
      ) : associations.isSuccess ? (
        <AssociationsTable associations={associations.data} />
      ) : (
        <p>No associations found.</p>
      )}
    </ExpandableCard>
  );
}

function AssociationsTable(props: { associations: ContractorAssociations }) {
  return (
    <>
      <div className="d-block d-md-none">
        <MobileView {...props} />
      </div>
      <div className="d-none d-md-block">
        <DesktopView {...props} />
      </div>
    </>
  );
}

function DesktopView({ associations }: { associations: ContractorAssociations }) {
  return (
    <table className="table table-sm table-fixed table-borderless mb-0">
      <thead>
        <tr>
          <th>Owners</th>
          <th>Welding Inspectors</th>
          <th>Welding/NDE Specialists</th>
          <th>Favorited</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ul>
              {associations.owners.length > 0 ? (
                associations.owners.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
              ) : (
                <li>None</li>
              )}
            </ul>
          </td>
          <td>
            <ul>
              {associations.inspectors.length > 0 ? (
                associations.inspectors.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
              ) : (
                <li>None</li>
              )}
            </ul>
          </td>
          <td>
            <ul>
              {associations.specialists.length > 0 ? (
                associations.specialists.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
              ) : (
                <li>None</li>
              )}
            </ul>
          </td>
          <td>
            <ul>
              {associations.favorited.length > 0 ? (
                associations.favorited.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
              ) : (
                <li>None</li>
              )}
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

function MobileView({ associations }: { associations: ContractorAssociations }) {
  return (
    <>
      <span className="fw-bold">Owners</span>
      <ul className="mb-3">
        {associations.owners.length > 0 ? (
          associations.owners.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
        ) : (
          <li>None</li>
        )}
      </ul>

      <span className="fw-bold">Welding Inspectors</span>
      <ul className="mb-3">
        {associations.inspectors.length > 0 ? (
          associations.inspectors.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
        ) : (
          <li>None</li>
        )}
      </ul>

      <span className="fw-bold">Welding/NDE Specialists</span>
      <ul className="mb-3">
        {associations.specialists.length > 0 ? (
          associations.specialists.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
        ) : (
          <li>None</li>
        )}
      </ul>

      <span className="fw-bold">Favorited</span>
      <ul>
        {associations.favorited.length > 0 ? (
          associations.favorited.map((user) => <li key={user.id}>{user.name ?? user.userName}</li>)
        ) : (
          <li>None</li>
        )}
      </ul>
    </>
  );
}
